export async function GetProfileData(id, offset, amount){

    let URL = ``

    if(offset === undefined && amount === undefined){
        URL = `/api/gallery/profiles/${id}`
    } else {
        URL = `/api/gallery/profiles/posts?amount=${amount}&offset=${offset}&id=${id}`
    }

        
    try{
        
        const response = await fetch(URL, {
            method: "GET",
            headers: {
                "Content-Type":"application/json"
            }
        });

        const responseData = await response.json();
        return responseData.data || [];  

    } catch(error){
        console.error(error);
        return [];
    }

}


export default GetProfileData